import React from 'react';

export const SectionLearning = ({ title, video }) => {
  return (
    <>
      <div className="flex flex-col items-center justify-center text-center max-container">
        {/* Header Section */}


        <div className="inline-block px-4 py-2 mt-12 bg-custom-yellow md:px-8 min-w-[300px]">
          <h2 className="text-lg font-bold text-center text-black md:text-xl lg:text-3xl">
            {title}
          </h2>
        </div>

        {/* Video Section */}
        {video && (
          <div className="mt-8">
            <video controls className="w-full">
              <source src={video} type="video/mp4" />
            </video>
          </div>
        )}
      </div>
    </>
  );
};
